import create from 'zustand'
import { UseFormReturn } from 'react-hook-form'

export const useEditBonusAmountModalStore = create<EditBonusAmountModalStoreState>((set) => ({
  editBonusAmountForm: null,
  isModalOpened: false,

  openBonusModal: () => set({ isModalOpened: true }),
  closeBonusModal: () => set({ isModalOpened: false }),
  cleanBonusModal: () => set({ editBonusAmountForm: null }),
  setEditBonusModalForm: (editBonusAmountForm: UseFormReturn<EditBonusAmountForm> | null) => set({ editBonusAmountForm }),
}))

export interface EditBonusAmountForm {
  bonusAmountField: number
}

export interface EditBonusAmountModalStoreState {
  editBonusAmountForm: UseFormReturn<EditBonusAmountForm> | null
  isModalOpened: boolean

  openBonusModal: () => void
  closeBonusModal: () => void
  cleanBonusModal: () => void
  setEditBonusModalForm: (editBonusAmountForm: UseFormReturn<EditBonusAmountForm> | null) => void
}
